window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Artboard155 = function() {
	this.initialize(img.MainAssets_Artboard155);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,996,170);


(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BackDown = function() {
	this.initialize(img.MainAssets_BackDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.Background_Grey = function() {
	this.initialize(img.MainAssets_Background_Grey);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BigPanelBG = function() {
	this.initialize(img.MainAssets_BigPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1080,1743);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Confetti_1 = function() {
	this.initialize(img.MainAssets_Confetti_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1739,1098);


(lib.Confetti_2 = function() {
	this.initialize(img.MainAssets_Confetti_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1733,1089);


(lib.EndscreenBGPanelLonger = function() {
	this.initialize(img.MainAssets_EndscreenBGPanelLonger);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,709);


(lib.FeedbackPanelBg = function() {
	this.initialize(img.MainAssets_FeedbackPanelBg);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,225,75);


(lib.Finishline = function() {
	this.initialize(img.MainAssets_Finishline);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,810,204);


(lib.Gas = function() {
	this.initialize(img.MainAssets_Gas);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,232,232);


(lib.Lane001 = function() {
	this.initialize(img.MainAssets_Lane001);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane002 = function() {
	this.initialize(img.MainAssets_Lane002);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane003 = function() {
	this.initialize(img.MainAssets_Lane003);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.Lane004 = function() {
	this.initialize(img.MainAssets_Lane004);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,216,1082);


(lib.LaneDividerLine = function() {
	this.initialize(img.MainAssets_LaneDividerLine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,805,9);


(lib.line1 = function() {
	this.initialize(img.MainAssets_line1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,15,1098);


(lib.LongerMainButtonDis = function() {
	this.initialize(img.MainAssets_LongerMainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonDown = function() {
	this.initialize(img.MainAssets_LongerMainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonHi = function() {
	this.initialize(img.MainAssets_LongerMainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonUp = function() {
	this.initialize(img.MainAssets_LongerMainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.MainButtonDis = function() {
	this.initialize(img.MainAssets_MainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDown = function() {
	this.initialize(img.MainAssets_MainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonHi = function() {
	this.initialize(img.MainAssets_MainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonUp = function() {
	this.initialize(img.MainAssets_MainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MarkerStartBmp = function() {
	this.initialize(img.MainAssets_MarkerStartBmp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,864,120);


(lib.Pattern_02_1000px = function() {
	this.initialize(img.MainAssets_Pattern_02_1000px);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,1000);


(lib.Pattern_04_1000px = function() {
	this.initialize(img.MainAssets_Pattern_04_1000px);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,200,1000);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDotpngcopy = function() {
	this.initialize(img.MainAssets_ProgressDotpngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,34,34);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressLine = function() {
	this.initialize(img.MainAssets_ProgressLine);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,250,20);


(lib.Racecar = function() {
	this.initialize(img.MainAssets_Racecar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,251,284);


(lib.RacerProgress = function() {
	this.initialize(img.MainAssets_RacerProgress);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,267,92);


(lib.RacerSpeedPanelBG = function() {
	this.initialize(img.MainAssets_RacerSpeedPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,996,270);


(lib.RacerTutorialPanel1 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,803,358);


(lib.RacerTutorialPanel2 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,802,224);


(lib.RacerTutorialPanel3 = function() {
	this.initialize(img.MainAssets_RacerTutorialPanel3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,992,517);


(lib.Racingillustration = function() {
	this.initialize(img.MainAssets_Racingillustration);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,2109);


(lib.ShapeCircle = function() {
	this.initialize(img.MainAssets_ShapeCircle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,128,128);


(lib.ShapeDiamond = function() {
	this.initialize(img.MainAssets_ShapeDiamond);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,122,123);


(lib.ShapeStar = function() {
	this.initialize(img.MainAssets_ShapeStar);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,124,118);


(lib.ShapeTriangle = function() {
	this.initialize(img.MainAssets_ShapeTriangle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,121,107);


(lib.Speedometer_Arrow = function() {
	this.initialize(img.MainAssets_Speedometer_Arrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,38,87);


(lib.Speedometer_Increments = function() {
	this.initialize(img.MainAssets_Speedometer_Increments);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,217,74);


(lib.Speedometer_RingBG2 = function() {
	this.initialize(img.MainAssets_Speedometer_RingBG2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,228,228);


(lib.TutorialPanelArrow = function() {
	this.initialize(img.MainAssets_TutorialPanelArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,121,170);


(lib.WhiteArrow = function() {
	this.initialize(img.MainAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);


(lib.Woosh_00000 = function() {
	this.initialize(img.MainAssets_Woosh_00000);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00001 = function() {
	this.initialize(img.MainAssets_Woosh_00001);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00002 = function() {
	this.initialize(img.MainAssets_Woosh_00002);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00003 = function() {
	this.initialize(img.MainAssets_Woosh_00003);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00004 = function() {
	this.initialize(img.MainAssets_Woosh_00004);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00005 = function() {
	this.initialize(img.MainAssets_Woosh_00005);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00006 = function() {
	this.initialize(img.MainAssets_Woosh_00006);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00007 = function() {
	this.initialize(img.MainAssets_Woosh_00007);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);


(lib.Woosh_00008 = function() {
	this.initialize(img.MainAssets_Woosh_00008);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,206);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Woosh_Animation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// Layer_1
	this.instance = new lib.Woosh_00000();
	this.instance.setTransform(-148.5,-103);

	this.instance_1 = new lib.Woosh_00001();
	this.instance_1.setTransform(-148.5,-103);

	this.instance_2 = new lib.Woosh_00002();
	this.instance_2.setTransform(-148.5,-103);

	this.instance_3 = new lib.Woosh_00003();
	this.instance_3.setTransform(-148.5,-103);

	this.instance_4 = new lib.Woosh_00004();
	this.instance_4.setTransform(-148.5,-103);

	this.instance_5 = new lib.Woosh_00005();
	this.instance_5.setTransform(-148.5,-103);

	this.instance_6 = new lib.Woosh_00006();
	this.instance_6.setTransform(-148.5,-103);

	this.instance_7 = new lib.Woosh_00007();
	this.instance_7.setTransform(-148.5,-103);

	this.instance_8 = new lib.Woosh_00008();
	this.instance_8.setTransform(-148.5,-103);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-148.5,-103,297,206);


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.TutorialStep1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actionTextfield
	this.actionTextfield = new cjs.Text("Press to continue", "36px 'Poppins'", "#0F5184");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.lineHeight = 63;
	this.actionTextfield.lineWidth = 885;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(-445.5,-695.5021);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.timeline.addTween(cjs.Tween.get(this.actionTextfield).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("You control the orange race car.\n\nYou can switch lanes by clicking the lane you want to move to.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 891;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445.5,-1061.05);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// panel bg
	this.instance = new lib.RacerTutorialPanel3();
	this.instance.setTransform(-496,-1127);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep1, new cjs.Rectangle(-496,-1222,992,612), null);


(lib.TutorialArrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutorialPanelArrow();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialArrow, new cjs.Rectangle(0,0,121,170), null);


(lib.StartContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhDgAJQIAAyfMCHBAAAIAASfg");
	this.shape.setTransform(432.075,59.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.StartContainer, new cjs.Rectangle(0,0,864.2,118.4), null);


(lib.SpeedMeterOrange = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF931E").s().p("ADqQZQiOgnh9hLQh3hHhihkQhhhjhGh4QhIh8gliKQgliLAAiQQAAiPAliLQAliKBIh8QBGh4BihjQBhhjB3hHQB9hMCOgnQCPgnCTAAQARAAAMAMQALALAAARQAAAQgLAMQgMAMgRAAQiIAAiEAkQiEAkh1BGQjiCIiEDpQiEDpAAEHQAAEJCEDoQCEDpDiCIQB1BGCEAkQCDAkCJAAQARAAAMAMQALAMAAAQQAAARgLAMQgMALgRAAQiUAAiOgng");
	this.shape.setTransform(-52.225,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpeedMeterOrange, new cjs.Rectangle(-108.6,-108.8,217.2,217.7), null);


(lib.SpeedMeterMask = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FA0002").s().p("ADqQZQiOgnh9hLQh3hHhihkQhhhjhGh4QhIh8gliKQgliLAAiQQAAiPAliLQAliKBIh8QBGh4BihjQBhhjB3hHQB9hMCOgnQCPgnCTAAQARAAAMAMQALALAAARQAAAQgLAMQgMAMgRAAQiIAAiEAkQiEAkh1BGQjiCIiEDpQiEDpAAEHQAAEJCEDoQCEDpDiCIQB1BGCEAkQCDAkCJAAQARAAAMAMQALAMAAAQQAAARgLAMQgMALgRAAQiUAAiOgng");
	this.shape.setTransform(-52.225,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpeedMeterMask, new cjs.Rectangle(-108.6,-108.8,217.2,217.7), null);


(lib.SpeedMeterGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#00CC39").s().p("ADqQZQiOgnh9hLQh3hHhihkQhhhjhGh4QhIh8gliKQgliLAAiQQAAiPAliLQAliKBIh8QBGh4BihjQBhhjB3hHQB9hMCOgnQCPgnCTAAQARAAAMAMQALALAAARQAAAQgLAMQgMAMgRAAQiIAAiEAkQiEAkh1BGQjiCIiEDpQiEDpAAEHQAAEJCEDoQCEDpDiCIQB1BGCEAkQCDAkCJAAQARAAAMAMQALAMAAAQQAAARgLAMQgMALgRAAQiUAAiOgng");
	this.shape.setTransform(-52.225,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpeedMeterGreen, new cjs.Rectangle(-108.6,-108.8,217.2,217.7), null);


(lib.ShapeTriangleSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeTriangle();
	this.instance.setTransform(-60.5,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeTriangleSkin, new cjs.Rectangle(-60.5,-64,121,107), null);


(lib.ShapeStarSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeStar();
	this.instance.setTransform(-64,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeStarSkin, new cjs.Rectangle(-64,-64,124,118), null);


(lib.ShapeDiamondSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeDiamond();
	this.instance.setTransform(-63,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeDiamondSkin, new cjs.Rectangle(-63,-64,122,123), null);


(lib.ShapeCircleSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ShapeCircle();
	this.instance.setTransform(-65,-64);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ShapeCircleSkin, new cjs.Rectangle(-65,-64,128,128), null);


(lib.SectionDividerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bar
	this.instance = new lib.LaneDividerLine();
	this.instance.setTransform(-431.85,-4.75,1.0732,1.0647);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SectionDividerSkin, new cjs.Rectangle(-431.8,-4.7,863.8,9.600000000000001), null);


(lib.RoadDividerssidesonly = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1 copy 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EBCzCnbMAAAlO2IBaABMAAAFO2gEhEMCnbMAAAlO2IBaABMAAAFO2g");
	this.shape.setTransform(0,-102.0875);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadDividerssidesonly, new cjs.Rectangle(-436.5,-1173.6,873,2143.1), null);


(lib.RoadTileYellow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane003();
	this.instance.setTransform(-108,-1080.85,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileYellow, new cjs.Rectangle(-108,-1080.8,216,1083), null);


(lib.RoadTileGrey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Pattern_04_1000px();
	this.instance.setTransform(-108,-1080,1.08,1.081);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CCC8C9").s().p("EgQ3BUYMAAAiovMAhvAAAMAAACovg");
	this.shape.setTransform(0,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileGrey, new cjs.Rectangle(-108,-1080,216,1081), null);


(lib.RoadTileGreen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane001();
	this.instance.setTransform(-108,-1080.9,1,1.001);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileGreen, new cjs.Rectangle(-108,-1080.9,216,1083.1000000000001), null);


(lib.RoadTileDarkGrey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Pattern_02_1000px();
	this.instance.setTransform(-108,-1080,1.08,1.081);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#95918E").s().p("EgQ3BUYMAAAiovMAhvAAAMAAACovg");
	this.shape.setTransform(0,-540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileDarkGrey, new cjs.Rectangle(-108,-1080,216,1081), null);


(lib.RoadTileBrown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane004();
	this.instance.setTransform(-108,-1081.05,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileBrown, new cjs.Rectangle(-108,-1081,216,1083), null);


(lib.RoadTileBlue = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Lane002();
	this.instance.setTransform(-108,-1080.75,1,1.0009);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileBlue, new cjs.Rectangle(-108,-1080.7,216,1083), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.ProgressDot2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDotpngcopy();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDot2, new cjs.Rectangle(0,0,34,34), null);


(lib.ProgressBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressLine();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressBar, new cjs.Rectangle(0,0,250,20), null);


(lib.PracticeRoundLabel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.textfield = new cjs.Text("Practice round", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 79;
	this.textfield.lineWidth = 368;
	this.textfield.parent = this;
	this.textfield.setTransform(498,8);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// Layer_1
	this.instance = new lib.Artboard155();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeRoundLabel, new cjs.Rectangle(0,0,996,170), null);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhmrikcMDNXAAAQCjAAAACbMAAAFECQAACcijAAMjNXAAAQijAAAAicMAAAlECQAAibCjAAg");
	this.shape.setTransform(673.475,1052.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0E95FD").s().p("EhmrCkdQijAAAAicMAAAlEBQAAicCjAAMDNXAAAQCjAAAACcMAAAFEBQAACcijAAg");
	this.shape_1.setTransform(673.475,1052.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.HudBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.RacerSpeedPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBackground, new cjs.Rectangle(0,0,996,270), null);


(lib.Gas_Circle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Gas();
	this.instance.setTransform(-116,-116);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Gas_Circle, new cjs.Rectangle(-116,-116,232,232), null);


(lib.SpeedometerPointer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Speedometer_Arrow();
	this.instance.setTransform(-19,-69.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpeedometerPointer, new cjs.Rectangle(-19,-69.2,38,87), null);


(lib.FinishTile = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Finishline();
	this.instance.setTransform(-429,-107.5,1.0645,1.0646);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FinishTile, new cjs.Rectangle(-429,-107.5,862.3,217.2), null);


(lib.Finish = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.finishTextfield = new cjs.Text("FINISH!", "bold 90px 'Poppins ExtraBold'", "#FFFFFF");
	this.finishTextfield.name = "finishTextfield";
	this.finishTextfield.textAlign = "center";
	this.finishTextfield.lineHeight = 161;
	this.finishTextfield.lineWidth = 354;
	this.finishTextfield.parent = this;
	this.finishTextfield.setTransform(1.15,-188.75,3,3);
ranj.TextOffsetFixer.fix(this.finishTextfield);

	this.timeline.addTween(cjs.Tween.get(this.finishTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Finish, new cjs.Rectangle(-536.1,-194.7,1074.7,1075.2), null);


(lib.EmptyTutorialStep = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.DividerLineDashed = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.line1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DividerLineDashed, new cjs.Rectangle(0,0,15,1098), null);


(lib.Countdown3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.text = new cjs.Text("3", "bold 220px 'Poppins ExtraBold'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 390;
	this.text.lineWidth = 196;
	this.text.parent = this;
	this.text.setTransform(9.8,-416.1,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown3, new cjs.Rectangle(-289.9,-422.1,599.4,1190.5), null);


(lib.Countdown2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.text = new cjs.Text("2", "bold 220px 'Poppins ExtraBold'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 390;
	this.text.lineWidth = 198;
	this.text.parent = this;
	this.text.setTransform(5,-442.1,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown2, new cjs.Rectangle(-298,-448.1,606.2,1190.5), null);


(lib.Countdown1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.text = new cjs.Text("1", "bold 220px 'Poppins ExtraBold'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 390;
	this.text.lineWidth = 198;
	this.text.parent = this;
	this.text.setTransform(3,-441.9,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown1, new cjs.Rectangle(-300,-447.9,606.2,1190.5), null);


(lib.Countdown0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.text = new cjs.Text("GO!", "bold 120px 'Poppins ExtraBold'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 213;
	this.text.lineWidth = 355;
	this.text.parent = this;
	this.text.setTransform(-1.85,-214.75,3,3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Countdown0, new cjs.Rectangle(-540.6,-220.7,1077.7,662.4), null);


(lib.Confetti2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Confetti_2();
	this.instance.setTransform(-866.5,-3267);

	this.instance_1 = new lib.Confetti_2();
	this.instance_1.setTransform(-866.5,-2178);

	this.instance_2 = new lib.Confetti_2();
	this.instance_2.setTransform(-866.5,-1089);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Confetti2, new cjs.Rectangle(-866.5,-3267,1733,3267), null);


(lib.Confetti1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Confetti_1();
	this.instance.setTransform(-869.5,-3289.5);

	this.instance_1 = new lib.Confetti_1();
	this.instance_1.setTransform(-869.5,-2191.5);

	this.instance_2 = new lib.Confetti_1();
	this.instance_2.setTransform(-869.5,-1093.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Confetti1, new cjs.Rectangle(-869.5,-3289.5,1739,3294), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "39px 'Poppins SemiBold'", "#0F97FF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 70;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(0.0002,-35.25);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.instance = new lib.FeedbackPanelBg();
	this.instance.setTransform(-113,-38);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113,-38,225,75.3), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.StartGameButtonWide = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 386;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-97,-36.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 386;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-97,-36.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 386;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-97,-36.2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Weiter", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 386;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-97,-36.2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.LongerMainButtonUp();
	this.instance_1.setTransform(-309,-63);

	this.instance_2 = new lib.LongerMainButtonHi();
	this.instance_2.setTransform(-309,-63);

	this.instance_3 = new lib.LongerMainButtonDown();
	this.instance_3.setTransform(-311,-63);

	this.instance_4 = new lib.LongerMainButtonDis();
	this.instance_4.setTransform(-310,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-311,-63,520,126);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-32.95,-36);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.MainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,129);


(lib.BottomBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-682.7,-125,1350,399.7);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Racingillustration();
	this.instance.setTransform(-540.5,-1744);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-540.5,-1744,1334,2109), null);


(lib.TutorialStep5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actionTextfield
	this.actionTextfield = new cjs.Text("Press to continue", "36px 'Poppins'", "#0F5184");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.lineHeight = 63;
	this.actionTextfield.lineWidth = 885;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(-445.5,-695.5021);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.timeline.addTween(cjs.Tween.get(this.actionTextfield).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("try to keep the number of moves you make in a level to a minimum", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 891;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445.5,-1061.05);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// arrow
	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(0,-1137,1,1,180,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// panel bg
	this.instance_1 = new lib.RacerTutorialPanel3();
	this.instance_1.setTransform(-496,-1127);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep5, new cjs.Rectangle(-496,-1222,992,612), null);


(lib.TutorialStep4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("Change your lane and see how your speed would change.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 713;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445.4,-493.0521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// arrow
	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(-103.5,-267.85,1,1,0,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.instance_1 = new lib.RacerTutorialPanel2();
	this.instance_1.setTransform(-491,-544);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep4, new cjs.Rectangle(-491,-544,802,361.2), null);


(lib.TutorialStep3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// actionTextfield
	this.actionTextfield = new cjs.Text("Press to continue", "36px 'Poppins'", "#0F5184");
	this.actionTextfield.name = "actionTextfield";
	this.actionTextfield.lineHeight = 63;
	this.actionTextfield.lineWidth = 885;
	this.actionTextfield.parent = this;
	this.actionTextfield.setTransform(-445.5,-695.5021);
ranj.TextOffsetFixer.fix(this.actionTextfield);

	this.timeline.addTween(cjs.Tween.get(this.actionTextfield).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("The speedometer shows how fast you are going.\n\nYour speed is determined by the lane you are in.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 891;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445.5,-1061.05);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// arrow
	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(0,-1137,1,1,180,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// panel bg
	this.instance_1 = new lib.RacerTutorialPanel3();
	this.instance_1.setTransform(-496,-1127);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep3, new cjs.Rectangle(-496,-1222,992,612), null);


(lib.TutorialStep2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("You control the orange race car.\n\nYou can switch lanes by clicking the lane you want to move to.", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 51;
	this.bodyTextfield.lineWidth = 713;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445.4,-493.0521);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// arrow
	this.instance = new lib.TutorialArrow();
	this.instance.setTransform(-326.75,-157.85,1,1,0,0,0,60.5,85);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.instance_1 = new lib.RacerTutorialPanel1();
	this.instance_1.setTransform(-491,-544);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialStep2, new cjs.Rectangle(-491,-544,803,471.2), null);


(lib.TutorialStep0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(3));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-422.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(3));

	// startButton
	this.startButton = new lib.StartGameButtonWide();
	this.startButton.name = "startButton";
	this.startButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(3));

	// Layer_3
	this.instance = new lib.BigPanelBG();
	this.instance.setTransform(-540,-871.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.8,-1079.1,1381.6,2149.3999999999996);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(266.45,591.8,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bodyTextField
	this.timeTextfield = new cjs.Text("Your time: 00:00.00", "bold 39px 'Poppins'", "#0F5184");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.lineHeight = 54;
	this.timeTextfield.lineWidth = 894;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(68.75,313.748);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.bodyTextfield = new cjs.Text("InstructionsInstructionsInstructionsInstructi", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 54;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(68.75,416.748);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bodyTextfield},{t:this.timeTextfield}]}).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Thanks for your effort!", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 72;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.EndscreenBGPanelLonger();
	this.instance.setTransform(1.05,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(1.1,0,1002,709), null);


(lib.RoadTileSeparator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DividerLineDashed();
	this.instance.setTransform(1.5,-538,1,1,0,0,0,8.5,542);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadTileSeparator, new cjs.Rectangle(-216,-1080,432,1098), null);


(lib.MarkerStart = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// StartText
	this.markerTextField = new cjs.Text("START", "bold 100px 'Poppins ExtraBold'", "#0F97FF");
	this.markerTextField.name = "markerTextField";
	this.markerTextField.textAlign = "center";
	this.markerTextField.lineHeight = 176;
	this.markerTextField.lineWidth = 859;
	this.markerTextField.parent = this;
	this.markerTextField.setTransform(-0.45,-137.4);
ranj.TextOffsetFixer.fix(this.markerTextField);

	this.timeline.addTween(cjs.Tween.get(this.markerTextField).wait(1));

	// StartContainer
	this.instance = new lib.StartContainer();
	this.instance.setTransform(-0.05,-61.3,1,1,0,0,0,432.1,59.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg BITMAPS
	this.instance_1 = new lib.MarkerStartBmp();
	this.instance_1.setTransform(-432,-120.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MarkerStart, new cjs.Rectangle(-432.1,-139.4,864.1,180.2), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_23 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(23).call(this.frame_23).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},23).wait(1));

	// Layer_4
	this.instance_1 = new lib.Tween2("synched",0);
	this.instance_1.setTransform(0,0,0.6452,0.6452);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},23).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.Gas_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Gas6 copy
	this.instance = new lib.Gas_Circle();
	this.instance.setTransform(-4,-137.25,0.13,0.13,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},197).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).wait(2));

	// Gas5 copy
	this.instance_1 = new lib.Gas_Circle();
	this.instance_1.setTransform(-18.75,-81.5,0.2404,0.2404,0,0,0,-0.2,-0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({regX:0,regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},172).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.2363,scaleY:0.2363,x:-18.2,y:-83.6},26).wait(1));

	// Gas4 copy
	this.instance_2 = new lib.Gas_Circle();
	this.instance_2.setTransform(-4,-26.25,0.3497,0.3497,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regY:0,scaleX:1,scaleY:1,y:302.3},148).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,regY:-0.5,scaleX:0.3454,scaleY:0.3454,x:-4.05,y:-28.45},50).wait(1));

	// Gas6
	this.instance_3 = new lib.Gas_Circle();
	this.instance_3.setTransform(47.05,29.15,0.4595,0.4595,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},123).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({regX:0.1,scaleX:0.4552,scaleY:0.4552,x:46.35,y:26.95},75).wait(1));

	// Gas5
	this.instance_4 = new lib.Gas_Circle();
	this.instance_4.setTransform(-62.6,84.65,0.5694,0.5694,0,0,0,0,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},98).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({regX:-0.1,scaleX:0.565,scaleY:0.565,x:-62.05,y:82.4},100).wait(1));

	// Gas4
	this.instance_5 = new lib.Gas_Circle();
	this.instance_5.setTransform(-4,138.85,0.6765,0.6765,0,0,0,0,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({regY:0,scaleX:1,scaleY:1,y:302.3},74).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,scaleX:0.6721,scaleY:0.6721,x:-4.05,y:136.6},124).wait(1));

	// Gas3
	this.instance_6 = new lib.Gas_Circle();
	this.instance_6.setTransform(97.6,194.05,0.7858,0.7858,0,0,0,0,-0.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({regY:0,scaleX:1,scaleY:1,x:130.85,y:302.3},49).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.7814,scaleY:0.7814,x:96.85,y:191.8},149).wait(1));

	// Gas2
	this.instance_7 = new lib.Gas_Circle();
	this.instance_7.setTransform(-106.1,249.25,0.8951,0.8951,0,0,0,-0.1,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).to({regX:0,regY:0,scaleX:1,scaleY:1,x:-120,y:302.3},24).to({regY:-0.4,scaleX:0.13,scaleY:0.13,x:-4,y:-137.25},1).to({scaleX:0.8907,scaleY:0.8907,x:-105.5,y:247.05},174).wait(1));

	// Gas1
	this.instance_8 = new lib.Gas_Circle();
	this.instance_8.setTransform(-4,302.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({regY:-0.4,scaleX:0.13,scaleY:0.13,y:-137.25},1).to({regX:-0.1,scaleX:0.9956,scaleY:0.9956,x:-4.1,y:300},198).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-236,-152.3,482.9,570.6);


(lib.Speedometer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pointer
	this.pointer = new lib.SpeedometerPointer();
	this.pointer.name = "pointer";
	this.pointer.setTransform(-0.95,16.65,1,1,-119.9992,0,0,-0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.pointer).to({regY:0.1,rotation:-58.001,x:-1,y:16.7},30).to({regX:0,regY:0,rotation:0,y:16.65},30).to({rotation:58,x:-0.95},30).to({rotation:119.9999,x:-1},30).wait(1));

	// meter overlay
	this.instance = new lib.Speedometer_RingBG2();
	this.instance.setTransform(-119,-92);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(121));

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AuwR+MAAAgj7IdhAAMAAAAj7g");
	mask.setTransform(-60.5,2);

	// RacerSpeedRed copy
	this.instance_1 = new lib.SpeedMeterMask();
	this.instance_1.setTransform(-5.25,21.95,1,1,-120.0004);

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({rotation:0,x:-5.3,y:22},60).wait(61));

	// RacerSpeedRed copy 2
	this.instance_2 = new lib.SpeedMeterOrange();
	this.instance_2.setTransform(-5.3,22);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(60).to({_off:false},0).to({scaleX:0.9999,scaleY:0.9999,rotation:58.0103,x:-5.25},30).wait(31));

	// Layer_7
	this.instance_3 = new lib.SpeedMeterGreen();
	this.instance_3.setTransform(-5.25,22,0.9999,0.9999,58.0103);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(90).to({_off:false},0).to({rotation:119.2421,y:22.1},30).wait(1));

	// bg color
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#B4C7D8").s().p("AsJMKQlClCAAnIQAAnHFClCQFClCHHAAQHIAAFCFCQFCFCAAHHQAAHIlCFCQlCFCnIAAQnHAAlClCg");
	this.shape.setTransform(-6.05,22.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(121));

	// Indicators
	this.instance_4 = new lib.Speedometer_Increments();
	this.instance_4.setTransform(-26.95,-23.6,0.2389,0.2389);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(121));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-197.5,-173.1,340.9,361.5);


(lib.RoadProgressBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// dot
	this.instance = new lib.ProgressDot2();
	this.instance.setTransform(16.95,69,1,1,0,0,0,17,17);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:244},99).wait(1));

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AxfGLQgpAAgegeQgdgcAAgqQAAgpAdgeQAegdApAAMAj7AAAQAqAAAdAdQAdAeAAApQAAAqgdAcQgdAegqAAg");
	mask.setTransform(128,39.5);

	// Layer_3
	this.instance_1 = new lib.ProgressBar();
	this.instance_1.setTransform(-100.75,69,1,1,0,0,0,125,10);

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({x:130},99).wait(1));

	// bg
	this.instance_2 = new lib.RacerProgress();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,267,92);


(lib.ProgressIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bar
	this.bar = new lib.RoadProgressBar();
	this.bar.name = "bar";

	this.timeline.addTween(cjs.Tween.get(this.bar).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressIndicator, new cjs.Rectangle(-225.7,0,492.7,92), null);


(lib.FinishMovieclip = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.finish = new lib.Finish();
	this.finish.name = "finish";
	this.finish.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.finish).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FinishMovieclip, new cjs.Rectangle(-536.1,-110.7,1074.7,1075.2), null);


(lib.CountdownSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// 3
	this.count3 = new lib.Countdown3();
	this.count3.name = "count3";
	this.count3.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.count3).wait(1));

	// 2
	this.count2 = new lib.Countdown2();
	this.count2.name = "count2";
	this.count2.setTransform(0,144.2,1,1,0,0,0,0,60.2);

	this.timeline.addTween(cjs.Tween.get(this.count2).wait(1));

	// 1
	this.count1 = new lib.Countdown1();
	this.count1.name = "count1";
	this.count1.setTransform(0,106.1,1,1,0,0,0,0,22.1);

	this.timeline.addTween(cjs.Tween.get(this.count1).wait(1));

	// 0
	this.count0 = new lib.Countdown0();
	this.count0.name = "count0";
	this.count0.setTransform(0,84);

	this.timeline.addTween(cjs.Tween.get(this.count0).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CountdownSkin, new cjs.Rectangle(-540.6,-364.1,1077.7,1201), null);


(lib.ConfettiLayers = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.confetti1 = new lib.Confetti1();
	this.confetti1.name = "confetti1";
	this.confetti1.setTransform(0,-4.5);

	this.timeline.addTween(cjs.Tween.get(this.confetti1).wait(1));

	// Layer_2
	this.confetti2 = new lib.Confetti2();
	this.confetti2.name = "confetti2";
	this.confetti2.setTransform(-3,0);

	this.timeline.addTween(cjs.Tween.get(this.confetti2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConfettiLayers, new cjs.Rectangle(-869.5,-3294,1739,3294), null);


(lib.CarTopview = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Gas
	this.gas = new lib.Gas_1();
	this.gas.name = "gas";
	this.gas.setTransform(-1.45,241.2,1,1,0,0,0,-4,-116);

	this.timeline.addTween(cjs.Tween.get(this.gas).wait(1));

	// car and shadow BITMAPS
	this.instance = new lib.Racecar();
	this.instance.setTransform(-110.45,-52.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarTopview, new cjs.Rectangle(-207.3,-52.7,398.6,828.2), null);


(lib.CarSpeedLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// left
	this.wooshLB = new lib.Woosh_Animation();
	this.wooshLB.name = "wooshLB";
	this.wooshLB.setTransform(-205.15,212.7,1,1,0,0,180);

	this.wooshLF = new lib.Woosh_Animation();
	this.wooshLF.name = "wooshLF";
	this.wooshLF.setTransform(-186.85,11.65,1,1,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.wooshLF},{t:this.wooshLB}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CarSpeedLines, new cjs.Rectangle(-353.6,-91.3,315.3,407), null);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// progressBar
	this.progressBar = new lib.ProgressIndicator();
	this.progressBar.name = "progressBar";
	this.progressBar.setTransform(193,23.55);

	this.timeline.addTween(cjs.Tween.get(this.progressBar).wait(1));

	// SpeedLabel BITMAPS
	this.speedLabelTextField = new cjs.Text("Geschwindigkeit", "39px 'Poppins SemiBold'", "#0F5184");
	this.speedLabelTextField.name = "speedLabelTextField";
	this.speedLabelTextField.textAlign = "center";
	this.speedLabelTextField.lineHeight = 69;
	this.speedLabelTextField.lineWidth = 368;
	this.speedLabelTextField.parent = this;
	this.speedLabelTextField.setTransform(0,197.75);
ranj.TextOffsetFixer.fix(this.speedLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.speedLabelTextField).wait(1));

	// HUD texts
	this.timeLabelTextfield = new cjs.Text("Elapsed time:", "39px 'Poppins'", "#0F5184");
	this.timeLabelTextfield.name = "timeLabelTextfield";
	this.timeLabelTextfield.lineHeight = 69;
	this.timeLabelTextfield.lineWidth = 370;
	this.timeLabelTextfield.parent = this;
	this.timeLabelTextfield.setTransform(-460.9,23.4);
ranj.TextOffsetFixer.fix(this.timeLabelTextfield);

	this.timeTextfield = new cjs.Text("00:00.00", "bold 39px 'Poppins'", "#0F5184");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.lineHeight = 69;
	this.timeTextfield.lineWidth = 242;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(-461.45,92.45);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.timeTextfield},{t:this.timeLabelTextfield}]}).wait(1));

	// speedometer
	this.speedometer = new lib.Speedometer();
	this.speedometer.name = "speedometer";
	this.speedometer.setTransform(6.25,107.9,1,1,0,0,0,0.1,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.speedometer).wait(1));

	// HUD background
	this.hudBackground = new lib.HudBackground();
	this.hudBackground.name = "hudBackground";
	this.hudBackground.setTransform(0,0,1,1,0,0,0,498,0);

	this.timeline.addTween(cjs.Tween.get(this.hudBackground).wait(1));

	// practiceRoundLabel
	this.practiceIndicator = new lib.PracticeRoundLabel();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(0,-85,1,1,0,0,0,498,0);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-691,-648.8,1382,927.3), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// Background
	this.bg = new lib.Background();
	this.bg.name = "bg";
	this.bg.setTransform(-126.5,951.95);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	// blue bg
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1184.2,1746.9,2501.2), null);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#DDE5EF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-84,-29);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.BackUp();
	this.instance.setTransform(-152,-18);

	this.instance_1 = new lib.BackDown();
	this.instance_1.setTransform(-152,-18);

	this.instance_2 = new lib.BackDisabled();
	this.instance_2.setTransform(-152,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},1).to({state:[]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(17.95,0.3,2.8787,1.5699,0,0,0,0.1,0.1);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-158.6,-31,352.6,83.3);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 25;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 25;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 25;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 25;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.RoadContents = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// speedlines
	this.speedlines = new lib.CarSpeedLines();
	this.speedlines.name = "speedlines";
	this.speedlines.setTransform(-2,-360);

	this.timeline.addTween(cjs.Tween.get(this.speedlines).wait(1));

	// car
	this.car = new lib.CarTopview();
	this.car.name = "car";
	this.car.setTransform(-2,-360);

	this.timeline.addTween(cjs.Tween.get(this.car).wait(1));

	// dividers
	this.dividers = new lib.RoadDividerssidesonly();
	this.dividers.name = "dividers";
	this.dividers.setTransform(0,-770);

	this.timeline.addTween(cjs.Tween.get(this.dividers).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoadContents, new cjs.Rectangle(-436.5,-1943.6,873,2359.1), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot6 = new lib.ProgressDot_1();
	this.dot6.name = "dot6";
	this.dot6.setTransform(144,0);

	this.dot0 = new lib.ProgressDot_1();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-144,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-96,0);

	this.dot5 = new lib.ProgressDot_1();
	this.dot5.name = "dot5";
	this.dot5.setTransform(96,0);

	this.dot4 = new lib.ProgressDot_1();
	this.dot4.name = "dot4";
	this.dot4.setTransform(48,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-48,0);

	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot3},{t:this.dot2},{t:this.dot4},{t:this.dot5},{t:this.dot1},{t:this.dot0},{t:this.dot6}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-159,-15,318,30), null);


(lib.GatekeeperTutorialStep = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// texts
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-422.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// startButton
	this.startButton = new lib.StartGameButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// prevButton
	this.replayButton = new lib.PrevButton();
	this.replayButton.name = "replayButton";
	this.replayButton.setTransform(-316.7,718,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.replayButton).wait(1));

	// bg panel
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape.setTransform(-0.025,-2.5601,1,1.2705);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(5.95,2.05,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperTutorialStep, new cjs.Rectangle(-684.8,-1072.7,1381.6,2149.5), null);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(0.05,-745.2);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// bottom bar
	this.bottomBar = new lib.BottomBar();
	this.bottomBar.name = "bottomBar";
	this.bottomBar.setTransform(8.05,869.95,1,1,0,0,0,0,-125);

	this.timeline.addTween(cjs.Tween.get(this.bottomBar).wait(1));

	// confetti
	this.confetti = new lib.ConfettiLayers();
	this.confetti.name = "confetti";
	this.confetti.setTransform(8.95,-539);

	this.timeline.addTween(cjs.Tween.get(this.confetti).wait(1));

	// road
	this.road = new lib.RoadContents();
	this.road.name = "road";
	this.road.setTransform(-1.8,183.85,1,1,0,0,0,-1.8,-687.2);

	this.timeline.addTween(cjs.Tween.get(this.road).wait(1));

	// bg
	this.instance = new lib.Background_Grey();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-860.5,-3833,1939.9,5119.4), null);


(lib.TutorialOverlaySkinOld = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {overlay1:0,overlay2:1,overlay3:2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Progress
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-0.45,822);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(3));

	// Layer_6
	this.cancelButton = new lib.PrevButton();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(267.25,1120.15,1,1,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get(this.cancelButton).wait(3));

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 95px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 87;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-436.6506,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(3));

	// texts
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-422.6,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(3));

	// nextButton
	this.nextButton = new lib.StartGameButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(245.2,729.6,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton).wait(3));

	// prevButton
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-316.7,718,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.prevButton).wait(3));

	// buttons next and prev
	this.nextButton_1 = new lib.NextButton();
	this.nextButton_1.name = "nextButton_1";
	this.nextButton_1.setTransform(260.2,324.3,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton_1).wait(3));

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(274.2,324,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(3));

	// Line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EggNBUNMAAAioZMBAbAAA");
	this.shape.setTransform(-244.8,85.725);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFFFF").ss(1,1,1).p("EArIgLVIAAWrMhWQAAA");
	this.shape_1.setTransform(-150.9,-331.25);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFFFF").ss(1,1,1).p("EgOYBGRIAAJAEgvzBGRIAAJAEgOYBGRMghbAAAEBFrhPQMiLVAAAMAAACVhIV3AAEAUQBGRIAAJAEAUQBGRMAhgAAAIAAJAEAUQBGRMgioAAA");
	this.shape_2.setTransform(-8.075,-34.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).wait(1));

	// Titles
	this.title1Textfield = new cjs.Text("xCONTROLS", "20px 'Roboto'", "#FFFFFF");
	this.title1Textfield.name = "title1Textfield";
	this.title1Textfield.lineHeight = 26;
	this.title1Textfield.lineWidth = 284;
	this.title1Textfield.parent = this;
	this.title1Textfield.setTransform(-136.7,-501.85);
ranj.TextOffsetFixer.fix(this.title1Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title1Textfield).to({_off:true},1).wait(2));

	// Titles
	this.title3Textfield = new cjs.Text("xLANES", "20px 'Roboto'", "#FFFFFF");
	this.title3Textfield.name = "title3Textfield";
	this.title3Textfield.lineHeight = 26;
	this.title3Textfield.lineWidth = 264;
	this.title3Textfield.parent = this;
	this.title3Textfield.setTransform(-426.2,-619.45,3,3);
	this.title3Textfield._off = true;
ranj.TextOffsetFixer.fix(this.title3Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title3Textfield).wait(2).to({_off:false},0).wait(1));

	// Titles
	this.title2Textfield = new cjs.Text("xSNELHEIDSMETE", "20px 'Roboto'", "#FFFFFF");
	this.title2Textfield.name = "title2Textfield";
	this.title2Textfield.lineHeight = 26;
	this.title2Textfield.lineWidth = 254;
	this.title2Textfield.parent = this;
	this.title2Textfield.setTransform(-426.2,-336.15,3,3);
	this.title2Textfield._off = true;
ranj.TextOffsetFixer.fix(this.title2Textfield);

	this.timeline.addTween(cjs.Tween.get(this.title2Textfield).wait(1).to({_off:false},0).to({_off:true},1).wait(1));

	// Text
	this.body1Textfield = new cjs.Text("• xYou control the red racing car\n\n• It is driving on a track with 4 different lanes\n\n• You switch lanes with your car by tapping on the lane you want to move to", "14px 'Poppins'", "#0F5184");
	this.body1Textfield.name = "body1Textfield";
	this.body1Textfield.lineHeight = 25;
	this.body1Textfield.lineWidth = 286;
	this.body1Textfield.parent = this;
	this.body1Textfield.setTransform(-134.95,-207.4);
ranj.TextOffsetFixer.fix(this.body1Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body1Textfield).to({_off:true},1).wait(2));

	// Text
	this.body3Textfield = new cjs.Text("x[• Using your speed gauge, you have to determine which of the lanes is the fastest\n\n• To get to the finish in as little time as possible, always try to be on the fastest lane\n\n• Only one of the lanes will be the fastest one]", "14px 'Roboto'", "#FFFFFF");
	this.body3Textfield.name = "body3Textfield";
	this.body3Textfield.lineHeight = 18;
	this.body3Textfield.lineWidth = 286;
	this.body3Textfield.parent = this;
	this.body3Textfield.setTransform(-426.2,-513.8,3,3);
	this.body3Textfield._off = true;
ranj.TextOffsetFixer.fix(this.body3Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body3Textfield).wait(2).to({_off:false},0).wait(1));

	// Text
	this.body2Textfield = new cjs.Text("x• Using your speed gauge, you have to determine which of the lanes is the \n\n• To get to the finish in as little time as possible, always try to be on the fastest\n\n• Only one of the lanes will be the fastest one", "14px 'Roboto'", "#FFFFFF");
	this.body2Textfield.name = "body2Textfield";
	this.body2Textfield.lineHeight = 18;
	this.body2Textfield.lineWidth = 286;
	this.body2Textfield.parent = this;
	this.body2Textfield.setTransform(-426.2,-226.1,3,3);
	this.body2Textfield._off = true;
ranj.TextOffsetFixer.fix(this.body2Textfield);

	this.timeline.addTween(cjs.Tween.get(this.body2Textfield).wait(1).to({_off:false},0).to({_off:true},1).wait(1));

	// bg panel
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape_3.setTransform(-0.025,-2.5601,1,1.2705);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(3));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-0.05,0.05,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-901.4,-1392.3,1984.8000000000002,2944.3999999999996);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// steps
	this.step0 = new lib.TutorialStep0();
	this.step0.name = "step0";
	this.step0.setTransform(0,-0.1);

	this.step1 = new lib.TutorialStep1();
	this.step1.name = "step1";
	this.step1.setTransform(0,750);

	this.step2 = new lib.TutorialStep2();
	this.step2.name = "step2";
	this.step2.setTransform(-1.95,164.85,1,1,0,0,0,1.3,1);

	this.step3 = new lib.TutorialStep3();
	this.step3.name = "step3";
	this.step3.setTransform(0,743.5);

	this.step4 = new lib.TutorialStep4();
	this.step4.name = "step4";
	this.step4.setTransform(-0.7,167.4,1,1,0,0,0,1.3,1);

	this.step5 = new lib.TutorialStep5();
	this.step5.name = "step5";
	this.step5.setTransform(-0.1,763.7,1,1,0,0,0,-0.1,20.2);

	this.step6 = new lib.EmptyTutorialStep();
	this.step6.name = "step6";
	this.step6.setTransform(-4.4,1.5);

	this.step7 = new lib.GatekeeperTutorialStep();
	this.step7.name = "step7";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.step0}]}).to({state:[{t:this.step1}]},1).to({state:[{t:this.step2}]},1).to({state:[{t:this.step3}]},1).to({state:[{t:this.step4}]},1).to({state:[{t:this.step5}]},1).to({state:[{t:this.step6}]},1).to({state:[{t:this.step7}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-684.8,-1180.2,1768.2,2257);


// stage content:
(lib.MainAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// finish
	this.finishMc = new lib.FinishMovieclip();
	this.finishMc.name = "finishMc";
	this.finishMc.setTransform(540,871,1.0005,1.0005);

	this.timeline.addTween(cjs.Tween.get(this.finishMc).wait(1));

	// countdown
	this.instance = new lib.CountdownSkin();
	this.instance.setTransform(540,871);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// tutorial
	this.instance_1 = new lib.TutorialOverlaySkinOld();
	this.instance_1.setTransform(720,1251.3,1,1,0,0,0,180,380.3);
	this.instance_1.cache(-903,-1394,1989,2948);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// road assets
	this.instance_2 = new lib.ShapeDiamondSkin();
	this.instance_2.setTransform(-1282.15,2322.95);

	this.instance_3 = new lib.ShapeTriangleSkin();
	this.instance_3.setTransform(-1460.7,2312.45);

	this.instance_4 = new lib.ShapeStarSkin();
	this.instance_4.setTransform(-1641.35,2312.45);

	this.instance_5 = new lib.ShapeCircleSkin();
	this.instance_5.setTransform(-1825,2322.95);

	this.instance_6 = new lib.FinishTile();
	this.instance_6.setTransform(-255.5,3915.35);

	this.instance_7 = new lib.SectionDividerSkin();
	this.instance_7.setTransform(-775.3,2525.9);

	this.instance_8 = new lib.MarkerStart();
	this.instance_8.setTransform(374.35,2763.7,1,1,0,0,0,0,-20);

	this.instance_9 = new lib.RoadTileGrey();
	this.instance_9.setTransform(-811.3,3741.2);

	this.instance_10 = new lib.RoadTileDarkGrey();
	this.instance_10.setTransform(-474.15,3721.2,1,1,0,0,0,0,-20);

	this.instance_11 = new lib.RoadTileGreen();
	this.instance_11.setTransform(-1947.8,3721.3,1,1,0,0,0,0,-20);

	this.instance_12 = new lib.RoadTileBlue();
	this.instance_12.setTransform(-1731.8,3721.25,1,1,0,0,0,0,-20);

	this.instance_13 = new lib.RoadTileYellow();
	this.instance_13.setTransform(-1515.8,3721.3,1,1,0,0,0,0,-20);

	this.instance_14 = new lib.RoadTileBrown();
	this.instance_14.setTransform(-1299.8,3721.3,1,1,0,0,0,0,-20);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// endscreen
	this.instance_15 = new lib.EndScreenSkin();
	this.instance_15.setTransform(1941.45,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).wait(1));

	// gamescreen
	this.instance_16 = new lib.FeedbackPanel();
	this.instance_16.setTransform(1575.35,2550.3,1,1,0,0,0,-0.5,-0.4);

	this.instance_17 = new lib.GameScreenSkin();
	this.instance_17.setTransform(720,1191,1,1,0,0,0,180,320);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-1515.8,-2091,4124.3,6116.1);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Artboard155.png", id:"MainAssets_Artboard155", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackDisabled.png", id:"MainAssets_BackDisabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackDown.png", id:"MainAssets_BackDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Background_Grey.png", id:"MainAssets_Background_Grey", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BackUp.png", id:"MainAssets_BackUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/BigPanelBG.png", id:"MainAssets_BigPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Confetti_1.png", id:"MainAssets_Confetti_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Confetti_2.png", id:"MainAssets_Confetti_2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EndscreenBGPanelLonger.png", id:"MainAssets_EndscreenBGPanelLonger", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPanelBg.png", id:"MainAssets_FeedbackPanelBg", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Finishline.png", id:"MainAssets_Finishline", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Gas.png", id:"MainAssets_Gas", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane001.png", id:"MainAssets_Lane001", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane002.png", id:"MainAssets_Lane002", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane003.png", id:"MainAssets_Lane003", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Lane004.png", id:"MainAssets_Lane004", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LaneDividerLine.png", id:"MainAssets_LaneDividerLine", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/line1.png", id:"MainAssets_line1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDis.png", id:"MainAssets_LongerMainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDown.png", id:"MainAssets_LongerMainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonHi.png", id:"MainAssets_LongerMainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonUp.png", id:"MainAssets_LongerMainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDis.png", id:"MainAssets_MainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDown.png", id:"MainAssets_MainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonHi.png", id:"MainAssets_MainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonUp.png", id:"MainAssets_MainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MarkerStartBmp.png", id:"MainAssets_MarkerStartBmp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Pattern_02_1000px.png", id:"MainAssets_Pattern_02_1000px", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Pattern_04_1000px.png", id:"MainAssets_Pattern_04_1000px", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDotpngcopy.png", id:"MainAssets_ProgressDotpngcopy", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressLine.png", id:"MainAssets_ProgressLine", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Racecar.png", id:"MainAssets_Racecar", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerProgress.png", id:"MainAssets_RacerProgress", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerSpeedPanelBG.png", id:"MainAssets_RacerSpeedPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel1.png", id:"MainAssets_RacerTutorialPanel1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel2.png", id:"MainAssets_RacerTutorialPanel2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/RacerTutorialPanel3.png", id:"MainAssets_RacerTutorialPanel3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Racingillustration.png", id:"MainAssets_Racingillustration", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeCircle.png", id:"MainAssets_ShapeCircle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeDiamond.png", id:"MainAssets_ShapeDiamond", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeStar.png", id:"MainAssets_ShapeStar", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ShapeTriangle.png", id:"MainAssets_ShapeTriangle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_Arrow.png", id:"MainAssets_Speedometer_Arrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_Increments.png", id:"MainAssets_Speedometer_Increments", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Speedometer_RingBG2.png", id:"MainAssets_Speedometer_RingBG2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutorialPanelArrow.png", id:"MainAssets_TutorialPanelArrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/WhiteArrow.png", id:"MainAssets_WhiteArrow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00000.png", id:"MainAssets_Woosh_00000", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00001.png", id:"MainAssets_Woosh_00001", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00002.png", id:"MainAssets_Woosh_00002", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00003.png", id:"MainAssets_Woosh_00003", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00004.png", id:"MainAssets_Woosh_00004", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00005.png", id:"MainAssets_Woosh_00005", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00006.png", id:"MainAssets_Woosh_00006", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00007.png", id:"MainAssets_Woosh_00007", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Woosh_00008.png", id:"MainAssets_Woosh_00008", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;